import { combineReducers } from 'redux'

import refundRecipientForm from './refundRecipientForm'

const billingReducer = combineReducers({
  refundRecipientForm
})

export default billingReducer
